import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import VocabularyThemeList from './VocabularyThemeList';
import VocabularyThemeListService from '../services/VocabularyThemeListService';

class VocabularyThemeListContainer extends Component {
  componentDidMount() {
    VocabularyThemeListService.init();
  }

  render() {
    return (
      <VocabularyThemeList
        vocabularyThemes={toJS(VocabularyThemeListService.vocabularyThemes)}
        fetching={VocabularyThemeListService.fetch.fetching}
        pagination={toJS(VocabularyThemeListService.pagination)}
        onChange={VocabularyThemeListService.load}
        onRestore={VocabularyThemeListService.handleRestore}
        onDisable={VocabularyThemeListService.handleDisable}
      />
    );
  }
}

export default observer(VocabularyThemeListContainer);
